<template>
    <div v-show="nickname" :class="['inviter', { isH5: isH5 }]">
        <img v-if="avatar" class="avatar" :src="avatar">
        <span class="name" v-html="nickname"></span>
    </div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
import { isH5 } from './utils.js';

export default {
    props: {
        avatar: {
            type: String,
            default: '',
        },
        nickname: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isH5: isH5(),
        }
    },
};
</script>

<style lang="less" scoped>
.inviter {
    display: inline-flex;
    align-items: center;
    &.isH5 {
        .avatar {
            margin-right: 0.14rem;
            width: 0.5rem;
            height: 0.5rem;
            border-radius: 50%;
            overflow: hidden;
            flex-shrink: 0;
        }
        .name {
            font-size: 0.32rem;
            line-height: 1;
            color: #000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    &:not(.isH5) {
        .avatar {
            margin-right: 0.1rem;
            width: 0.4rem;
            height: 0.4rem;
            border-radius: 50%;
            overflow: hidden;
            flex-shrink: 0;
        }
        .name {
            font-size: 0.26rem;
            line-height: 1;
            color: #000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
</style>
